<template>
  <v-row align="center" justify="center">
    <v-col cols="12" lg="10">
      <v-card shaped>
        <v-card-title>
          <v-icon large left color="primary">mdi-trophy</v-icon>
          <span class="title font-weight-light">ТОП 100 продаваемых товаров за месяц</span>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="OpenManagersDialog">
            ТОП 1500 товаров
          </v-btn>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          :items-per-page="-1"
          hide-default-footer
          dense
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-center" style="width: 80px">{{ item.position }}</td>
              <td><i>{{ item.goodsFullName }}</i></td>
            </tr>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="managersDialog" max-width="600">
        <v-card>
          <v-card-title class="title font-weight-light">
            ТОП 1500 товаров
          </v-card-title>
          <v-card-text>
            <p>
              Для получения 1500 наименований самых продаваемых товаров, входящих
              в обязательный ассортимент аптеки, необходимо связаться с менеджером:
            </p>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">ФИО</th>
                    <th class="text-left">Номера</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(manager, i) in managers" :key="i">
                    <td>{{ manager.fullName }}</td>
                    <td>
                      <div>{{ manager.phoneNumber }}</div>
                      <div v-if="manager.whatsAppPhoneNumber">
                        <a :href="WhatsAppHref(manager)" target="_blank">
                          {{ manager.whatsAppPhoneNumber }}
                        </a>
                        <v-icon small color="green" class="ml-1">mdi-whatsapp</v-icon>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="managersDialog = false">Закрыть</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    items: [],
    managers: [],
    loading: false,
    managersDialog: false,
    headers: [
      { text: "№", sortable: false, align: "center" },
      { text: "Наименование товара", value: "goodsFullName", sortable: false },
    ],
  }),
  mounted() {
    this.GetReport();
  },
  methods: {
    async GetReport() {
      this.loading = true;
      try {
        this.items = await this.$store.dispatch("TOP_PRODUCTS_SOLD");
      } catch (error) {
        window.console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async OpenManagersDialog() {
      this.managersDialog = true;
      if (this.managers.length) return;
      try {
        this.managers = await this.$store.dispatch("GET_MANAGERS");
      } catch (error) {
        window.console.log(error);
      }
    },
    WhatsAppHref(manager) {
      return (
        manager.whatsAppLink ||
        `https://api.whatsapp.com/send?phone=${manager.whatsAppPhoneNumber.replace(/[^\d]/g, "")}`
      );
    },
  },
};
</script>
